<template>
	<v-alert
		:border="borderValue"
		:colored-border="coloredBorder"
		:dense="dense"
		:elevation="elevation"
		:outlined="outlined"
		:prominent="prominent"
		:text="text"
		:type="type"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot/>
	</v-alert>
</template>

<script>
export default {
	name: 'KAlert',
	inheritAttrs: false,
	computed: {
		borderValue() {
			if (this.border === true) return 'left';
			if (this.border === false) return undefined;
			return this.border;
		}
	},
	props: {
		border: {
			type: [Boolean, String],
			validator: (value) => {
				if (typeof value === 'boolean') return true;
				return ['top', 'right', 'bottom', 'left'].includes(value);
			},
			default: false
		},
		coloredBorder: Boolean,
		dense: Boolean,
		elevation: {
			type: [Number, String],
			default: undefined
		},
		outlined: Boolean,
		prominent: Boolean,
		text: Boolean,
		type: {
			type: String,
			validator: (value) => ['error', 'info', 'success', 'warning'].includes(value),
			default: undefined
		},
	}
};
</script>